export function randomId(length: number = 8): string {
  const g = globalThis as unknown as {
    crypto?: { randomUUID?: () => string; getRandomValues?: (a: Uint8Array) => Uint8Array };
  };
  if (g.crypto?.randomUUID) {
    return g.crypto.randomUUID().slice(0, length);
  }
  if (g.crypto?.getRandomValues) {
    const bytes = new Uint8Array(length);
    g.crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => (b % 36).toString(36)).join("");
  }
  let out = "";
  while (out.length < length) out += Math.random().toString(36).slice(2);
  return out.slice(0, length);
}
